"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceScheme_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ServiceSchemeType_1 = require("./ServiceSchemeType");
var ServiceScheme_Factory = /** @class */ (function () {
    function ServiceScheme_Factory() {
    }
    ServiceScheme_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            LegacyKeyHash: model.LegacyKeyHash,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SchemeName: model.SchemeName,
            SchemeType: model.SchemeType,
            ServiceSchemeType: ServiceSchemeType_1.ServiceSchemeType_Factory.CreateIncoming(model.ServiceSchemeType),
        };
        return result;
    };
    ServiceScheme_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            LegacyKeyHash: model.LegacyKeyHash,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SchemeName: model.SchemeName,
            SchemeType: model.SchemeType,
            ServiceSchemeType: ServiceSchemeType_1.ServiceSchemeType_Factory.CreateOutgoing(model.ServiceSchemeType),
        };
        return result;
    };
    return ServiceScheme_Factory;
}());
exports.ServiceScheme_Factory = ServiceScheme_Factory;
